import { Button, Modal, Pagination, Stack, Text, Thumbnail, Tooltip, Badge } from "@shopify/polaris";
import { DeleteMinor, ImageMajor, UndoMajor } from "@shopify/polaris-icons";

import { OPEN_MODAL_TARGETED_PRODUCTS } from "../../../constants/modalTypes.js";
import TargetedProductsTable from "../../common/TargetedProductsTable/TargetedProductsTable.js";
import { triggerAttributes } from "../../../helpers/triggerAttributes.js";
import { cutTitle } from "../../../utils/cutTitle.js";
import { useAppSelector } from "../../../hooks/redux.js";

const tableHeadings = [
  // "#",
  "Product",
  "",
  "Stock Quantity",
  "FilterType",
  ""
];

const tableColumnContentTypes = [
  // "numeric",
  "text",
  "numeric",
  "numeric",
  "text"
];

const TargetedProductsModal = ({
  isLoading,
  products,
  hasPrevious,
  hasNext,
  handleDelete,
  handlePrevious,
  handleNext,
  handleCloseModal,
  exceptionList,
  handleUndoDeletedProduct
}) => {
  const { isOpen, modalType } = useAppSelector((state) => state.modal);

  const rowsMarkup = products.map(
    (item, index) => {
      return (
        [
          // index + 1,
          <Stack wrap={false} alignment="center">
            <Thumbnail
              source={item.featuredImage || ImageMajor}
              size="small"
              alt={item.title}
            />
            <Tooltip content={item.title}>
              <Text as="span" variant="bodyMd">
                {cutTitle({ title: item.title, maxLength: 30 })}
              </Text>
            </Tooltip>
          </Stack>,
          exceptionList.includes(item.id) ? <Badge status="warning">Excepted</Badge> : "",
          item.totalInventory || "-",
          triggerAttributes[item.triggerAttribute] || "-",
          exceptionList.includes(item.id)
            ? <Button icon={UndoMajor} onClick={() => handleUndoDeletedProduct(item.id)} />
            : <Button icon={DeleteMinor} onClick={() => handleDelete(item.id)} />
        ]
      );
    }
  );

  return (
    <Modal
      open={isOpen && modalType === OPEN_MODAL_TARGETED_PRODUCTS}
      onClose={handleCloseModal}
      title="Targeted products"
      large
    >
      <Modal.Section>
        <TargetedProductsTable
          headings={tableHeadings}
          columnContentTypes={tableColumnContentTypes}
          rows={rowsMarkup}
        />
      </Modal.Section>
      <Modal.Section>
        <Stack distribution={"center"}>
          {isLoading ? <Button loading /> :
            <Pagination
              hasPrevious={hasPrevious}
              onPrevious={handlePrevious}
              hasNext={hasNext}
              onNext={handleNext}
            />
          }
        </Stack>
      </Modal.Section>
    </Modal>
  );
};

export default TargetedProductsModal;